import api, { convertToISODateTime, handleApiError } from './client';

export const revenueService = {
  /**
   * Get revenue statistics across the 4 categories
   */
  getRevenue: async (startDate, endDate) => {
    try {
      const params = {};
      if (startDate) params.startDate = convertToISODateTime(startDate);
      if (endDate) params.endDate = convertToISODateTime(endDate);

      const response = await api.get('/api/statistics/revenue', { params });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching revenue statistics:', error);
      return handleApiError(error, 'Errore nel caricamento delle statistiche di incasso');
    }
  }
};
